export default __webpack_public_path__ + "static/column-pescatarian-2-22b2064eb26246efa37529889cf29d99.jpg";